import {useAppSelector} from "../../../redux/hooks";
import {useEffect} from "react";
import productMonitoring from "../../../services/log/productMonitoring";
import {myProfileStore} from "../../../redux/my-profile/myProfileStore";


export const useProductMonitoringIdentifyLogic = (): void => {
  // initialize on first load
  useEffect(() => {
    productMonitoring.initialize();
  }, []);

  const isMyProfileReady = useAppSelector(myProfileStore.getIsMyProfileReady);
  const firstName = useAppSelector(myProfileStore.getMyProfileFirstName);
  const lastName = useAppSelector(myProfileStore.getMyProfileLastName);
  const userId = useAppSelector(myProfileStore.getMyProfileUserId);
  const username = useAppSelector(myProfileStore.getMyProfileUsername);
  const sessionId = useAppSelector(myProfileStore.getMyProfileSessionId);
  // when isMyProfileReady changes
  useEffect(() => {
    if (!isMyProfileReady){
      // not ready and nothing to do
      return;
    }
    // finished loading
    void productMonitoring.identifySession({userId, firstName, lastName, sessionId, username});
  }, [isMyProfileReady, userId, sessionId, firstName, lastName, username]);

}
